import axios from 'axios';
import { apiMainUrl } from '../apiConfig';
import { normalizeRuntimeCompanyAccess } from '../Models/SecurityModels';

const profilesUrl = `${apiMainUrl}company-access-profiles`;
const effectiveUrl = `${apiMainUrl}company-access/effective`;
const auth = token => ({ headers: { Authorization: `Bearer ${token}` } });
const withParams = (token, params) => ({ ...auth(token), params: Object.fromEntries(
    Object.entries(params || {}).filter(([, item]) => item !== undefined && item !== null && item !== '')
) });
const page = response => ({
    items: response?.items ?? response?.Items ?? [],
    page: response?.page ?? response?.Page ?? 1,
    pageSize: response?.pageSize ?? response?.PageSize ?? 50,
    totalCount: response?.totalCount ?? response?.TotalCount ?? 0,
    totalPages: response?.totalPages ?? response?.TotalPages ?? 0
});

const getRuntimeAccess = async (token, resourceCode) => normalizeRuntimeCompanyAccess((await axios.get(
    `${apiMainUrl}Users/me/company-access`, withParams(token, { resourceCode })
)).data);
const getProfiles = async (query, token) => page((await axios.get(profilesUrl, withParams(token, query))).data);
const getProfile = async (id, token) => (await axios.get(`${profilesUrl}/${id}`, auth(token))).data;
const createProfile = async (body, token) => (await axios.post(profilesUrl, body, auth(token))).data;
const updateProfile = async (id, body, token) => (await axios.put(`${profilesUrl}/${id}`, body, auth(token))).data;
const setProfileStatus = async (id, isActive, token) => (await axios.patch(
    `${profilesUrl}/${id}/status`, { isActive }, auth(token)
)).data;

const collection = (name, optionName, payloadName) => ({
    assigned: async (id, token) => (await axios.get(`${profilesUrl}/${id}/${name}`, auth(token))).data,
    options: async (id, query, token) => page((await axios.get(`${profilesUrl}/${optionName}-options`,
        withParams(token, { profileId: id, ...query }))).data),
    replace: async (id, ids, token) => (await axios.put(`${profilesUrl}/${id}/${name}`, { [payloadName]: ids }, auth(token))).data
});
const companies = collection('companies', 'company', 'companyIds');
const roles = collection('roles', 'role', 'roleIds');
const users = collection('users', 'user', 'userIds');
const getResources = async (id, token) => (await axios.get(`${profilesUrl}/${id}/resources`, auth(token))).data;
const replaceResources = async (id, resources, token) => (await axios.put(
    `${profilesUrl}/${id}/resources`, { resources }, auth(token)
)).data;

const effectiveByUser = async (userId, query, token) => page((await axios.get(
    `${effectiveUrl}/users/${userId}`, withParams(token, query)
)).data);
const effectiveByCompany = async (companyId, query, token) => page((await axios.get(
    `${effectiveUrl}/companies/${companyId}`, withParams(token, query)
)).data);

export const CompanyAccessDataService = {
    getRuntimeAccess, getProfiles, getProfile, createProfile, updateProfile, setProfileStatus,
    companies, roles, users, getResources, replaceResources, effectiveByUser, effectiveByCompany
};
